import React from 'react';
import EndpointCard from '../EndpointCard';

const Logs = () => {
  return (
    <section className="section">
      <h2 className="section-title">Logs</h2>

      <EndpointCard
        method="GET"
        path="/sops/{generation_id}/stream"
        title="Stream Logs"
        description="Streams real-time logs for an SOP generation task using Server-Sent Events (SSE)."
        tags={['SSE Stream', 'Authentication: Required']}
      >
        <p className="text-sm text-gray-300">
          This endpoint uses Server-Sent Events (SSE) to stream real-time logs from SOP generation tasks.
        </p>
      </EndpointCard>
    </section>
  );
};

export default Logs;
